/**
 * A state hospital unit (the server's STATE_MODE_GROUPS, tasks/state-mode.md). Nothing reaches outside the system for
 * it: no invites, sending, patient app, referrals, MedicAI Connect, financials or lab orders. Everything that would is
 * hidden, not disabled. Internal chat and RelayMD stay.
 */
export function isStateModeGroup(group: { stateMode?: boolean } | null | undefined): boolean {
  return group?.stateMode === true;
}
